import jQuery from "jquery";
import gsap from 'gsap';
import { ACTION, Events } from '../events'

jQuery(document).ready(function ($) {
    let $homePageHeader = $('.ex-home-page-header');

    if ($homePageHeader.length === 0)
        return false;

    let $t1 = $homePageHeader.find('.t1');
    let $t2 = $homePageHeader.find('.t2');
    let $buttonWhite = $homePageHeader.find('.button-white');
    let $bg = $homePageHeader.find('.ex-home-page-header-bg');
    let $header = $("header.et-headerHolder");
    let $socials = $(".ex-header-social-media-row");
    let $boxes = $(".ex-header-3boxes");

    let topOffset = $header.height() / 2 - 75;
    gsap.set($t1, {x: -100,  alpha: 0});
    gsap.set($t2, {x: 100, alpha: 0});
    gsap.set($buttonWhite,  {alpha: 0});
    gsap.set($bg, {alpha: 0});
    gsap.set($socials, {alpha: 0});

    gsap.set($header, {y: $header.height() * -1});

    let sceneDuration = 0.5;
    var tl = gsap.timeline({})
        .to($bg, {duration: sceneDuration, alpha: 1, ease: "none"}, 0)
        .to($t1, {duration: sceneDuration, x: 0, alpha: 1, ease: "power2.out"})
        .to($t2, {duration: sceneDuration, x: 0, alpha: 1, ease: "power2.out"}, "-=0.2")
        .to($buttonWhite, {duration: sceneDuration, x: 0, alpha: 1, ease: "power1.out"}, "-=0.2")
        .add("content")
        .to($header, {duration: sceneDuration, y: 0, ease: "power2.out"}, ">")
        .to($('.ex-header-3boxes-section'), {
            duration: sceneDuration,
            css: {marginTop: -155, autoRound: false},
            ease: "power2.out"
        }, "content+=0.6")
        .to($socials, {duration: sceneDuration, alpha: 1, ease: "power1.out", onComplete: () => {
                Events.emit(ACTION.HEADER_ANIMATION_FINISHED)
            }}, ">")

    gsap.fromTo($bg, {scale: 1.4}, {duration: 2, scale: 1, ease: "power3.out"});

});